import React, { useEffect, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';

import api from '../../../../services/api';
import history from '../../../../services/history';

import TitleBar from '../../../../components/TitleBar';

import { Reordenar } from './styles';
import { AppError } from '../../../../errors/AppError';
import Loading from '../../../../components/Loading';
import InputDefault from '../../../../components/InputDefault';

import TableHeader from '../../../../components/Table/TableHeader';
import { Table, RowMaster } from '../../../../components/Table';

function CatalogoOrdenarPaginasInseridas() {
  const location = useLocation();

  const [paginasOrdenar, setPaginasOrdenar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [novaOrdenacao, setNovaOrdenacao] = useState({});

  const { idCatalogo } = location.state;

  const carregaAtualizacaoOrdena = useCallback(async () => {
    await api
      .get(`catalogo/imagem-ultima-atualizacao/${idCatalogo}`)
      .then((response) => {
        const instLido = response.data?.instLido ?? null;
        const faltaOrdenar = response.data?.faltaOrdenar ?? [];

        if (instLido) {
          history.goBack();
        }

        setPaginasOrdenar(faltaOrdenar);
        setNovaOrdenacao({});
      });
  }, [idCatalogo]);

  useEffect(() => {
    carregaAtualizacaoOrdena();
  }, [carregaAtualizacaoOrdena]);

  const handleNovaOrdenacao = (index, valor) => {
    setNovaOrdenacao((prevDados) => ({
      ...prevDados,
      [index]: { ...prevDados[index], valor },
    }));
  };

  const handleOrdenar = useCallback(
    async (index, idPagina) => {
      const ordena = novaOrdenacao[index]?.valor;

      const ordenaNumerico = ordena === '' ? '' : Number(ordena);

      if (ordena === '' || Number.isNaN(ordenaNumerico)) {
        alert('Por favor, insira um número válido.');
        return;
      }
      setLoading(true);
      try {
        await api.patch(`catalogo/${idCatalogo}/ordenar-insercao/${idPagina}`, {
          novoOrdena: ordena,
        });
      } catch (err) {
        AppError(err);
      } finally {
        setLoading(false);
      }

      carregaAtualizacaoOrdena();
    },
    [novaOrdenacao, carregaAtualizacaoOrdena, idCatalogo]
  );

  return (
    <>
      <TitleBar title="Ordenar páginas" />

      <Table>
        <TableHeader
          withPadding
          titles={[
            { fieldname: 'idPagina', title: 'Página Atual' },
            { fieldname: 'ordem', title: 'Ordem Atual' },
            { fieldname: 'novoOrdena', title: 'Nova Ordem' },
            { fieldname: 'ordenar', title: 'Ordenar' },
            { fieldname: null, title: null },
          ]}
          cbSort={() => {}}
        />
        <tbody>
          {paginasOrdenar &&
            paginasOrdenar.map((element, index) => (
              <RowMaster key={element.idPagina}>
                <td>{element.idPagina}</td>
                <td>{element.ordena}</td>
                <td>
                  <InputDefault
                    id="novaOrdenacao"
                    name="novaOrdenacao"
                    type="number"
                    onChange={(e) => handleNovaOrdenacao(index, e.target.value)}
                    width={100}
                  />
                </td>
                <td>
                  <Reordenar
                    type="submit"
                    onClick={(e) => {
                      handleOrdenar(index, element.idPagina);
                    }}
                  >
                    Reordenar
                  </Reordenar>
                </td>
              </RowMaster>
            ))}
        </tbody>
      </Table>
      <Loading visible={loading} />
    </>
  );
}

export { CatalogoOrdenarPaginasInseridas };
